import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Analytics } from "@vercel/analytics/react";
import { App } from "./App";
import "./index.css";

Sentry.init({
	dsn: "https://ddc7d53d74ce61760dde691c4208be25@o4510526488051712.ingest.de.sentry.io/4510851545235536",
	sendDefaultPii: true,
	enableLogs: true,
});

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
	<StrictMode>
		<App />
		<Analytics />
	</StrictMode>,
);
